import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonToolbar
} from "@ionic/react";
import LevelsCard from "./LevelsCardComponent";
import { arrayOfCards } from "./levelsData";
import { closeOutline } from "ionicons/icons";

export interface LevelsModalProps {
  modalIsOpen: boolean;
  modalIsDismissed: () => void;
}

const LevelsModal: React.FC<LevelsModalProps> = ({
  modalIsOpen,
  modalIsDismissed
}) => {
  return (
    <IonModal isOpen={modalIsOpen} onDidDismiss={() => modalIsDismissed()}>
      <IonHeader>
        <IonToolbar className="ion-no-padding">
          <div className="flex items-center py-4 bg-primary-80">
            <div className="ml-4 mt-6 text-lg">Levels</div>
            <div className="ml-auto mr-4 mt-6">
              <IonButton
                fill="solid"
                color="primary"
                onClick={() => modalIsDismissed()}
              >
                <IonIcon icon={closeOutline} className="text-black" />
              </IonButton>
            </div>
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent
        fullscreen
        scrollY={false}
        className="h-screen levels-custom flex "
      >
        <div className="flex flex-col justify-between py-4">
          <div className="mx-4 mt-2 text-sm">
            Successful trades help you climb your way up the
          </div>
          <div className="mx-4 text-sm">
            levels, unlock features and tools along the way
          </div>
          <div>
            {arrayOfCards.map(cardProps => (
              <LevelsCard
                key={cardProps.id}
                rankIcon={cardProps.icon}
                title={cardProps.title}
                titleColor={cardProps.titleColor}
                rankList={cardProps.rankList}
              />
            ))}
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default LevelsModal;
